import { render, staticRenderFns } from "./OrganismMenuBarEmbedProject.vue?vue&type=template&id=a430c95e&"
import script from "./OrganismMenuBarEmbedProject.vue?vue&type=script&lang=js&"
export * from "./OrganismMenuBarEmbedProject.vue?vue&type=script&lang=js&"
import style0 from "./OrganismMenuBarEmbedProject.vue?vue&type=style&index=0&id=a430c95e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default,AtomsCommonAtomLogo: require('/app/components/atoms/common/AtomLogo.vue').default,AtomsCommonAtomLocaleSwitch: require('/app/components/atoms/common/AtomLocaleSwitch.vue').default})
